/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface DeleteReseller200Response
 */
export interface DeleteReseller200Response {
    /**
     * 
     */
    message: string;
}

/**
 * Check if a given object implements the DeleteReseller200Response interface.
 */
export function instanceOfDeleteReseller200Response(value: object): value is DeleteReseller200Response {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function DeleteReseller200ResponseFromJSON(json: any): DeleteReseller200Response {
    return DeleteReseller200ResponseFromJSONTyped(json, false);
}

export function DeleteReseller200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteReseller200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function DeleteReseller200ResponseToJSON(json: any): DeleteReseller200Response {
    return DeleteReseller200ResponseToJSONTyped(json, false);
}

export function DeleteReseller200ResponseToJSONTyped(value?: DeleteReseller200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

